import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const validationSchema = Yup.object().shape({
  consumerInfo: Yup.object().shape({
    consumerName: Yup.object().nullable().required('Consumer Name is required'),
  }),
  transportationInfo: Yup.object().shape({}),
  shippingInfo: Yup.object().shape({
    shippingAddress: Yup.string().nullable().required('Shipping Address is required'),
    city: Yup.string().nullable().required('City is required'),
    state: Yup.string().nullable(),
    zip: Yup.string().nullable(),
    name: Yup.string().nullable(),
  }),
})

export const formOptions = { resolver: yupResolver(validationSchema) }

export default validationSchema
